const SELECTORS = {
  form: '[data-company-rank-form]',
  relationTypeSelect: '#company_relation_type',
  rankSelect: '#company_cooperation_rank',
  rankField: '[data-company-rank-field]',
  relationTypeInlineError: '[data-company-rank-relation-type-error]',
  relationTypeInlineErrorWrapper: '[data-company-rank-relation-type-error-wrapper]'
};
const EVENT_NAMES = ['DOMContentLoaded', 'turbolinks:load', 'turbo:load'];
const COOP_RELATION_TYPE = 'coop';
const UNEVALUATED_RANK = 'unevaluated';

const getJQuery = () => window.jQuery || window.$;

const setSemanticDropdownValue = (select, value) => {
  select.value = value;

  const $ = getJQuery();
  if (!$) return;

  const $select = $(select);
  if (typeof $select.dropdown === 'function') {
    $select.dropdown('set selected', value);
  }
};

const setHidden = (element, hidden) => {
  if (!element) return;
  element.hidden = hidden;
};

const setInlineError = (textElement, wrapperElement, message) => {
  if (!textElement) return;

  textElement.textContent = message || '';
  setHidden(wrapperElement || textElement, !message);
};

const isCoopRelationType = (value) => value === COOP_RELATION_TYPE;
const isUnevaluatedRank = (value) => value === UNEVALUATED_RANK;

export class CompanyRankFormController {
  constructor(form) {
    this.form = form;
    this.relationTypeSelect = form.querySelector(SELECTORS.relationTypeSelect);
    this.rankSelect = form.querySelector(SELECTORS.rankSelect);
    this.rankField = form.querySelector(SELECTORS.rankField);
    this.relationTypeInlineError = form.querySelector(SELECTORS.relationTypeInlineError);
    this.relationTypeInlineErrorWrapper = form.querySelector(SELECTORS.relationTypeInlineErrorWrapper);
    this.lockedMessage = form.dataset.companyRankLockedMessage || '';
    this.previousRelationTypeValue = this.relationTypeSelect ? this.relationTypeSelect.value : null;
  }

  connect() {
    if (!this.relationTypeSelect || !this.rankSelect || !this.rankField) return;
    if (this.form.dataset.companyRankFormInitialized === 'true') return;

    this.relationTypeSelect.addEventListener('change', this.handleRelationTypeChange);
    this.rankSelect.addEventListener('change', this.handleRankChange);
    this.refresh();

    this.form.dataset.companyRankFormInitialized = 'true';
  }

  handleRelationTypeChange = () => {
    if (!isCoopRelationType(this.relationTypeSelect.value) && !isUnevaluatedRank(this.rankSelect.value)) {
      this.showLockedError();
      this.revertRelationTypeSelection();
      return;
    }

    this.previousRelationTypeValue = this.relationTypeSelect.value;
    this.refresh();
  };

  handleRankChange = () => {
    this.refresh();
  };

  revertRelationTypeSelection() {
    setSemanticDropdownValue(this.relationTypeSelect, this.previousRelationTypeValue);
    this.refresh({ keepError: true });
  }

  showLockedError() {
    setInlineError(this.relationTypeInlineError, this.relationTypeInlineErrorWrapper, this.lockedMessage);
  }

  refresh({ keepError = false } = {}) {
    const relationTypeValue = this.relationTypeSelect.value;
    const rankValue = this.rankSelect.value;
    const rankVisible = isCoopRelationType(relationTypeValue);
    const shouldShowError = !rankVisible && !isUnevaluatedRank(rankValue);

    setHidden(this.rankField, !rankVisible);

    if (keepError) return;

    setInlineError(
      this.relationTypeInlineError,
      this.relationTypeInlineErrorWrapper,
      shouldShowError ? this.lockedMessage : ''
    );
  }
}

export const initializeCompanyRankForms = () => {
  const forms = Array.from(document.querySelectorAll(SELECTORS.form));
  forms.forEach((form) => {
    new CompanyRankFormController(form).connect();
  });
};

EVENT_NAMES.forEach((eventName) => {
  document.addEventListener(eventName, initializeCompanyRankForms);
});
